// import { state } from "./content.model";

export const categoryList: any[] = [
  { name: 'Service Year Guide', code: 'service year guide book:NTK' },
  { name: 'Camp Life', code: 'camp_life' },
  { name: 'Job Listing', code: 'jobs' }
];
